<div
  class="card modern-card"
  [class.full-width]="!isStandaloneProfile"
>
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">{{ isStandaloneProfile ? 'My Profile' : 'User Management' }}</h1>
      </div>
      @if (missing_fields.length) {
        <div class="header-alert d-flex align-items-center" role="alert">
          <i class="fa-solid fa-circle-exclamation me-2"></i>
          <span class="header-alert-prefix">Please fill in:</span>
          <div class="header-alert-chips">
            @for (field of missing_fields; track field) {
              <span class="header-alert-chip">{{ field }}</span>
            }
          </div>
          <button type="button" class="header-alert-close ms-2" aria-label="Dismiss" (click)="missing_fields = []">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      }
    </div>
  </div>

  <div class="card-body px-4 pb-4">
    <b class="text-danger">*</b>
    <span> Denotes required fields</span>

    <form
      class="mt-3"
      [formGroup]="user_form"
      (ngSubmit)="AddEditClick()"
      autocomplete="off"
      style="margin: 0 auto"
    >
      <!-- First Name & Last Name -->
      <div class="row mb-3">
        <div class="col-md-6 form-group d-flex align-items-center mb-0">
          <label for="name_first" class="form-label"
            ><span class="text-danger">*</span> First Name:
          </label>
          <input
            appCapitalizeFirst
            type="text"
            class="form-control"
            formControlName="name_first"
          />
        </div>

        <div class="col-md-6 form-group d-flex align-items-center mb-0">
          <label for="name_last" class="form-label"
            ><span class="text-danger">*</span> Last Name:</label
          >
          <input
            appCapitalizeFirst
            type="text"
            class="form-control"
            formControlName="name_last"
          />
        </div>
      </div>
      <!-- Position Title & Role -->
      <div class="row mb-3">
        <div class="col-md-6 form-group d-flex align-items-center mb-0">
          <label for="position_title" class="form-label">Position Title:</label>
          <input
            appCapitalizeFirst
            type="text"
            class="form-control"
            formControlName="position_title"
          />
        </div>

        <div class="col-md-6 form-group d-flex align-items-center mb-0">
          <label for="role" class="form-label"
            ><span class="text-danger">*</span> Role:</label
          >
          <ng-select
            [items]="roles"
            [multiple]="false"
            [closeOnSelect]="true"
            [searchable]="false"
            [readonly]="!isAdmin()"
            appendTo="body"
            class="role-select form-control text-uppercase p-0 border-0 bg-transparent flex-grow-1"
            style="min-width: 0"
            formControlName="role"
          ></ng-select>
        </div>
      </div>
      <!-- Phone & Email -->
      <div class="row mb-3">
        <div class="col-md-6 form-group d-flex align-items-center mb-0">
          <label for="phone" class="form-label">Phone:</label>
          <input type="tel" class="form-control" formControlName="phone" />
        </div>

        <div class="col-md-6 form-group d-flex align-items-center mb-0">
          <label for="email" class="form-label"
            ><span class="text-danger">*</span> Email:</label
          >
          <input type="email" class="form-control" formControlName="email" />
        </div>
      </div>
      <!-- Username & Digital Signature -->
      <div class="row mb-3">
        <div class="col-md-6 form-group d-flex align-items-center mb-0">
          <label for="username" class="form-label"
            >Username:</label
          >
          <input
            type="text"
            class="form-control"
            formControlName="username"
            readonly
            style="opacity: 0.7; cursor: default;"
          />
        </div>

        <div class="col-md-6 form-group d-flex align-items-center mb-0">
          <label for="digital_signature" class="form-label"
            >Digital Signature:</label
          >
          <div class="input-group flex-nowrap" style="flex: 1">
            <input
              class="form-control border-end-0"
              formControlName="digital_signature"
            />
            @if (!user_form.get("digital_signature").value) {
              <button
                type="button"
                class="btn red-btn border-start-0"
                style="width: 50px"
                (click)="addDigitalSignature()"
                title="Add Digital Signature"
                [disabled]="
                  !user_form.get('name_first').value &&
                  !user_form.get('name_last').value
                "
              >
                <i class="fa-solid fa-plus"></i>
              </button>
            }
            @if (user_form.get("digital_signature").value) {
              <button
                type="button"
                class="btn yellow-btn border-start-0"
                style="width: 50px"
                (click)="editDigitalSignature()"
                title="Edit Digital Signature"
              >
                <i class="fa-solid fa-pen-to-square"></i>
              </button>
            }
          </div>
        </div>
      </div>
      <!-- Password & Confirm Password -->
      <div class="row mb-3">
        <div class="col-md-6 form-group d-flex align-items-center mb-0">
          <label for="password" class="form-label"
            ><span class="text-danger">*</span> Password:</label
          >
          <div class="input-icon-container" style="flex: 1">
            <input
              [type]="showPassword ? 'text' : 'password'"
              class="form-control"
              style="padding-right: 60px"
              formControlName="password"
              autocomplete="new-password"
            />
            @if (user_form.get("password")?.value) {
              <i
                [class]="
                  showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'
                "
                class="input-icon-eye"
                (click)="togglePasswordVisibility()"
                title="Toggle password visibility"
              ></i>
            }
            @if (
              user_form.value.password === user_form.value.password2 &&
              user_form.value.password &&
              user_form.value.password2
            ) {
              <i class="fa-solid fa-circle-check text-success input-icon"></i>
            }
            @if (
              user_form.value.password !== user_form.value.password2 &&
              user_form.value.password &&
              user_form.value.password2
            ) {
              <i class="fa-solid fa-circle-xmark text-danger input-icon"></i>
            }
          </div>
        </div>

        <div class="col-md-6 form-group d-flex align-items-center mb-0">
          <label for="password2" class="form-label"
            ><span class="text-danger">*</span> Re-enter Password:</label
          >
          <div class="input-icon-container" style="flex: 1">
            <input
              [type]="showPassword2 ? 'text' : 'password'"
              class="form-control"
              style="padding-right: 60px"
              formControlName="password2"
              autocomplete="new-password"
            />
            @if (user_form.get("password2")?.value) {
              <i
                [class]="
                  showPassword2 ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'
                "
                class="input-icon-eye"
                (click)="togglePassword2Visibility()"
                title="Toggle password visibility"
              ></i>
            }
            @if (
              user_form.value.password === user_form.value.password2 &&
              user_form.value.password &&
              user_form.value.password2
            ) {
              <i class="fa-solid fa-circle-check text-success input-icon"></i>
            }
            @if (
              user_form.value.password !== user_form.value.password2 &&
              user_form.value.password &&
              user_form.value.password2
            ) {
              <i class="fa-solid fa-circle-xmark text-danger input-icon"></i>
            }
          </div>
        </div>
      </div>
      <!-- buttons -->
      <div class="row mt-4 mb-2">
        <div class="col-md-6 form-group d-flex align-items-center mb-0">
          <div class="form-label"></div>
          <button
            class="btn grey-btn flex-grow-1"
            style="color: white"
            type="submit"
          >
            @if (!this.edit_user) {
              <span style="color: white"><i class="fa-solid fa-plus me-2"></i>Add User</span>
            }
            @if (this.edit_user) {
              <span style="color: white" ><i class="fa-solid fa-save me-2"></i>Update User</span>
            }
          </button>
        </div>

        <div class="col-md-6 form-group d-flex align-items-center mb-0">
          <div class="form-label"></div>
          <button
            class="btn grey-btn flex-grow-1"
            type="button"
            (click)="clearForm()"
            style="color: white"
          >
            <i class="fa-solid fa-times me-2"></i>Cancel
          </button>
        </div>
      </div>
    </form>

    <!-- User Table -->
    @if (!isStandaloneProfile) {
    <div class="mt-4" style="width: 100%; margin: 0 auto">
      <!-- Title -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0 text-light section-header w-100">
          Users
        </h4>
      </div>
      <ag-grid-angular
        id="dispo_list"
        class="modern-grid"
        style="width: 100%; height: 325px"
        
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [gridOptions]="gridOptions"
        [rowData]="getUsers()"
        [overlayLoadingTemplate]="overlayLoadingTemplate"
        [animateRows]="true"
        [components]="components"
        [enableBrowserTooltips]="true"
      ></ag-grid-angular>
    </div>
    }
  </div>
</div>
